module.exports = __webpack_public_path__ + "assets/media/desktop-illustration.b196b228.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoSuccessStep/desktop-illustration.png
// module id = 3229
// module chunks = 0